<div class="custom-date-range-picker" [class.disabled]="disabled" clickOutside (clickOutside)="closeCalendar()">
  <!-- Input Field -->
  <div class="date-input-container" (click)="toggleCalendar()">
    <input 
      type="text" 
      class="date-input" 
      [placeholder]="placeholder"
      [value]="getDisplayValue()"
      [disabled]="disabled"
      readonly
    />
    <div class="calendar-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="clear-button" *ngIf="selectedRange.startDate || selectedRange.endDate" (click)="clearRange(); $event.stopPropagation()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <!-- Calendar Dropdown -->
  <div class="calendar-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <!-- Range Display -->
    <div class="range-display" *ngIf="selectedRange.startDate || selectedRange.endDate">
      <div class="range-item">
        <span class="range-label">From:</span>
        <span class="range-date" [class.selected]="selectedRange.startDate">
          {{ selectedRange.startDate ? selectedRange.startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Select Start Date' }}
        </span>
      </div>
      <div class="range-item">
        <span class="range-label">To:</span>
        <span class="range-date" [class.selected]="selectedRange.endDate">
          {{ selectedRange.endDate ? selectedRange.endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Select End Date' }}
        </span>
      </div>
    </div>

    <!-- Calendar Header -->
    <div class="calendar-header">
      <div class="month-year" (click)="toggleMonthYearView()">
        {{ getMonthYearDisplay() }}
        <div class="dropdown-arrow" [class.rotated]="isMonthYearView || isYearView">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="navigation-arrows">
        <button class="nav-arrow" (click)="previousMonth()" type="button" *ngIf="!isMonthYearView && !isYearView">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-arrow" (click)="nextMonth()" type="button" *ngIf="!isMonthYearView && !isYearView">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-arrow" (click)="previousYearRange()" type="button" *ngIf="isYearView">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-arrow" (click)="nextYearRange()" type="button" *ngIf="isYearView">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Month Selection View -->
    <div class="month-year-view" *ngIf="isMonthYearView">
      <div class="month-year-header">
        <div class="year-display" (click)="goToYearView()">
          {{ currentMonth.getFullYear() }}
          <div class="up-arrow">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="navigation-arrows">
          <button class="nav-arrow" (click)="previousMonth()" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="nav-arrow" (click)="nextMonth()" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="month-grid">
        <div 
          class="month-item" 
          *ngFor="let month of months; let i = index"
          [class.selected]="i === currentMonth.getMonth()"
          (click)="selectMonth(i)"
        >
          {{ month.substring(0, 3) }}
        </div>
      </div>
    </div>

    <!-- Year Selection View -->
    <div class="year-view" *ngIf="isYearView">
      <div class="year-header">
        <div class="year-range">
          {{ yearRange[0] }} - {{ yearRange[yearRange.length - 1] }}
          <div class="up-arrow">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L12 9L6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="navigation-arrows">
          <button class="nav-arrow" (click)="previousYearRange()" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="nav-arrow" (click)="nextYearRange()" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="year-grid">
        <div 
          class="year-item" 
          *ngFor="let year of yearRange"
          [class.selected]="year === currentMonth.getFullYear()"
          (click)="selectYear(year)"
        >
          {{ year }}
        </div>
      </div>
    </div>

    <!-- Regular Calendar View -->
    <div *ngIf="!isMonthYearView && !isYearView">
      <!-- Week Days Header -->
      <div class="week-days">
        <div class="week-day" *ngFor="let day of weekDays">{{ day }}</div>
      </div>

      <!-- Calendar Grid -->
      <div class="calendar-grid">
        <div 
          class="calendar-day" 
          *ngFor="let date of calendarDays; let i = index"
          [class.other-month]="!isCurrentMonth(date)"
          [class.selected]="isSelected(date)"
          [class.in-range]="isInRange(date)"
          [class.in-hover-range]="isInHoverRange(date)"
          [class.today]="isToday(date)"
          [class.disabled]="isDisabled(date)"
          (click)="!isDisabled(date) && selectDate(date)"
          (mouseenter)="!isDisabled(date) && onDateMouseEnter(date)"
          (mouseleave)="onDateMouseLeave()"
        >
          {{ date.getDate() }}
        </div>
      </div>
    </div>
  </div>
</div> 